import React, { useState, useEffect } from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';


const InputForm = ({
    handleChange,
    handleBlur,
    values,
    name,
    autoComplete,
    autoFocus,
    label,
    touched,
    errors,
    type,
    disabled,
    helperText,
    fullWidth,
    size,
    margin,
    multiline,
    rows,
    children,
    select,
    InputProps,
    setOpenModal,
    menuItemArr,
    defaultMenuItem,
    alternateName
}) => {
    const [menuItemArrModify, setMenuItemArrModify] = useState([]);
    useEffect(() => {
        if (menuItemArr && menuItemArr.length) {
            setMenuItemArrModify(menuItemArr);
        }
    }, [menuItemArr]);

    const [openSelect, setOpenSelect] = useState(false);
    return (
        <TextField
            InputProps={InputProps}
            variant="outlined"
            margin={margin}
            select={select}
            size={size}
            multiline={multiline}
            rows={rows}
            SelectProps={{
                open: openSelect,
                onOpen: () => setOpenSelect(true),
                onClose: () => setOpenSelect(false)
            }}
            // required
            fullWidth={fullWidth}
            label={label}
            name={name}
            autoComplete={autoComplete}
            autoFocus={!!autoFocus}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values && values[name]}
            error={touched && touched[name] && errors && errors[name] && true}
            helperText={(touched && touched[name] && errors && errors[name]) || helperText}
            type={type}
            disabled={disabled}
        >
            {/* {menuItemArr && <div disabled className={cls.menu_item_scroll}>
                <div className={cls.menu_item_scroll_disbled}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}>
                    <div>{label}</div>
                    <div className={cls.close} onClick={()=>setOpenSelect(false)} />
                    <div className={cls.menu_wraper}>
                        <TextField
                            id="outlined-basic"
                            label="Поиск по наименованию"
                            size='small'
                            variant="outlined"
                            autoFocus
                            onKeyPress={({ charCode }) => {
                                if (charCode === 13) {
                                    changeArray();
                                }
                            }}
                            onChange={({ target: { value } }) => setChangeSearch(value)}
                            value={changeSearch}
                            InputProps={{
                                endAdornment: <>
                                    {changeSearch ? <IconButton
                                        size='small'
                                        edge="end"
                                        onClick={() => {
                                            setChangeSearch('');
                                            changeArray(true);
                                        }}
                                    ><CloseIcon />
                                    </IconButton> : ''}
                                    <IconButton
                                        onClick={() => changeArray()}
                                        size='small'
                                        edge="end"
                                    >
                                        <SearchIcon />
                                    </IconButton></>,
                            }}
                            style={{ marginRight: 10, width: '100%' }}
                        />
                        {setOpenModal && <ButtonStyle onClick={() => {
                            setOpenSelect(false);
                            setTimeout(() => setOpenModal(true), 0);
                        }} styleVariable='outlined'>...</ButtonStyle>}
                    </div>
                </div>
            </div>} */}
            {defaultMenuItem && menuItemArrModify.length > 0 && <MenuItem value={defaultMenuItem.value || ''}>
                <span style={{ opacity: 0 }}>_</span>{defaultMenuItem.name}
            </MenuItem>}
            {menuItemArr && menuItemArrModify
                .map((el, index) => {
                    const { name, value } = el;
                    return (
                        <MenuItem key={index} value={value}>
                            <span style={{ opacity: 0 }}>_</span>{name}{alternateName ? ` от ${el[alternateName]}` : ''}
                        </MenuItem>
                    )
                })}
            {menuItemArr && !menuItemArrModify.length &&
                <MenuItem>
                    <span style={{ opacity: 0 }}>_</span>пусто
                    </MenuItem>
            }
            {children}
        </TextField>
    )
}

InputForm.propTypes = {
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.shape({
        name: PropTypes.string
    }),
    errors: PropTypes.shape({
        name: PropTypes.string
    }),
    // touched: PropTypes.shape({
    //     name:PropTypes.string
    // }),
    name: PropTypes.string,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    label: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool
};

InputForm.defaultProps = {
    name: '',
    autoComplete: '',
    autoFocus: false,
    label: '',
    type: 'text',
    disabled: false,
    fullWidth: false,
    size: null,
    margin: 'none',
    multiline: false,
    rows: '1',
    children: null,
    select: false,
    InputProps: null,
    defaultMenuItem: null,
    setOpenModal: false,
    alternateName: ''
};


export default InputForm